<template>
    <canvas ref="canvas"></canvas>
</template>

<script>
    import qrcode from 'qrcode';// qrcode

    export default {
        name: 'QrCode',// 二维码组件
        props: {
            // 宽度
            width: {
                type: Number,
                default: 200
            },
            value: {
                type: String,
                default: ''
            },
        },
        watch: {
            width() {
                this.createQrCode();// 生成二维码
            },
            value() {
                this.createQrCode();// 生成二维码
            },
        },
        mounted() {
            this.createQrCode();// 生成二维码
        },
        methods: {
            // 生成二维码
            createQrCode() {
                qrcode.toCanvas(this.$refs.canvas, this.value, {
                    width: this.width
                });
            }
        }
    };
</script>

<style lang="scss" scoped>

</style>
